import { Divider, Tag } from 'antd';
import clsx from 'clsx';
import CatalogUtils from 'config/utils/catalog.util';
import React from 'react';
import styles from './style.module.scss';

type ProductTagsProps = {
  tags?: string[];
  limit?: number;
  reserveSpace?: boolean;
  withDivider?: boolean;
};

const ProductTags: React.FC<ProductTagsProps> = ({ tags, limit, reserveSpace = false, withDivider = false }) => {
  const visibleTags = CatalogUtils.getVisibleProductTags(tags, limit);

  if (!reserveSpace && visibleTags.length === 0) return null;

  const list = (
    <div className={clsx(styles['product-tags'], reserveSpace && styles['product-tags--reserved'])}>
      {visibleTags.map((tag) => (
        <Tag key={tag}>{tag}</Tag>
      ))}
    </div>
  );

  if (!withDivider) return list;

  return (
    <>
      <Divider className={styles['tags-divider']} />
      {list}
    </>
  );
};

export default ProductTags;
